import { useId, type FC, type ReactNode } from 'react';
import { Theme } from '@carbon/react';

import styles from './ConviteDoPro.module.scss';

// O CONVITE DO PRO, uma tela só para todo módulo travado (decisão do Lucas, 13/10/2026: a direção
// "C · Palco"). Um painel escuro (o tema g100, nos dois temas do app) com a luz de palco no roxo da
// Nyta: o módulo e o plano em cima, a frase do que ele faz, os benefícios em etiquetas e as ações.
// O convidado de um titular sem assinatura usa a mesma moldura, sem venda.

export const ConviteDoPro: FC<{
  /** O que vem acima do título: "Vendas · Maestra PRO", ou o nome do módulo para o convidado. */
  rotulo: string;
  titulo: string;
  texto?: string | null;
  apoio?: string | null;
  beneficios?: readonly string[];
  acoes: ReactNode;
}> = ({ rotulo, titulo, texto, apoio, beneficios = [], acoes }) => {
  const id = useId();
  return (
    <Theme theme='g100' className={styles.palco}>
      <section className={styles.conteudo} aria-labelledby={id}>
        <p className={styles.rotulo}>{rotulo}</p>
        <h2 id={id} className={styles.titulo}>{titulo}</h2>
        {texto && <p className={styles.texto}>{texto}</p>}
        {beneficios.length > 0 && (
          <ul className={styles.etiquetas} aria-label='O que vem no módulo'>
            {beneficios.map((b) => <li key={b} className={styles.etiqueta}>{b}</li>)}
          </ul>
        )}
        {apoio && <p className={styles.texto}>{apoio}</p>}
        <div className={styles.acoes}>{acoes}</div>
      </section>
    </Theme>
  );
};
